var primarySmall = {
  variant: 'primary',
  size: 'sm'
};
var primaryMedium = {
  variant: 'primary',
  size: 'md'
};
var primaryExtraLarge = {
  variant: 'primary',
  size: 'xl'
};
var primarySmallBold = {
  variant: 'primary',
  size: 'sm',
  weight: 'bold'
};
var primaryMediumBold = {
  variant: 'primary',
  size: 'md',
  weight: 'bold'
};
var secondarySmall = {
  variant: 'secondary',
  size: 'sm'
};
var secondaryMedium = {
  variant: 'secondary',
  size: 'md'
};
var newsSmall = {
  variant: 'secondary',
  size: 'sm',
  fontFamily: 'serif'
};
var newsMedium = {
  variant: 'secondary',
  size: 'md',
  fontFamily: 'serif'
};
var newsLarge = {
  variant: 'secondary',
  size: 'lg',
  fontFamily: 'serif'
};
var newsSmallBold = {
  variant: 'secondary',
  size: 'sm',
  weight: 'bold',
  fontFamily: 'serif'
};
var newsMediumBold = {
  variant: 'secondary',
  size: 'md',
  weight: 'bold',
  fontFamily: 'serif'
};
var headingPrimary = {
  variant: 'primary',
  size: 'heading',
  weight: 'bold'
};
var headingSecondary = {
  variant: 'secondary',
  size: 'heading',
  weight: 'bold'
};
var neutral = {
  variant: 'neutral'
};
var inherit = {
  variant: 'inherit'
};
var iconSecondary = {
  variant: 'icon-secondary',
  size: 'md'
};
var menuItem = {
  variant: 'menu-item',
  size: 'md'
};
var anchorVariants = {
  'primary-sm': primarySmall,
  'primary-sm-bold': primarySmallBold,
  'primary-md': primaryMedium,
  'primary-md-bold': primaryMediumBold,
  'primary-xl': primaryExtraLarge,
  'secondary-sm': secondarySmall,
  'secondary-md': secondaryMedium,
  primary: headingPrimary,
  secondary: headingSecondary,
  'news-sm': newsSmall,
  'news-md': newsMedium,
  'news-lg': newsLarge,
  'news-sm-bold': newsSmallBold,
  'news-md-bold': newsMediumBold,
  neutral: neutral,
  inherit: inherit,
  'icon-secondary': iconSecondary,
  'menu-item': menuItem
};

export { anchorVariants };
//# sourceMappingURL=anchor.variants.esm.js.map
